<template>
  <div class="content" id="model">
    <ly-header></ly-header>
    <div class="jiankong" v-show="isShowstyle">
      <NumberSbjk></NumberSbjk>
    </div>
    <div class="shuidi" v-show="isShowstyle">
      <img class="shuidiimg" src="../assets/img/shuidi.png" alt />
    </div>
    <div class="baojing" v-show="isShowstyle">
      <NumberSsbj></NumberSsbj>
    </div>
    <div class="anniu">
      <!-- <btms :msg="msg" @click="hideBtn()"></btms> -->
      <div :msg="msg" @click="hideBtn()">隐藏面板</div>
    </div>
    <div class="shebei" v-show="isShowstyle">
      <img class="shebeiimg" src="../assets/img/shebei.png" alt />
    </div>
    <div class="zhouzhuanl" v-show="isShowstyle">
      <NumberZzl></NumberZzl>
    </div>
    <div class="dingdan" v-show="isShowstyle">
      <NumberDdgk></NumberDdgk>
    </div>
    <div class="gegekuqu">
      <div
        class="meige"
        :class="[{'xuanzhongimg':indeximg==index}]"
        @click="indexchange(index)"
        v-for="(item,index) in arr"
        :key="item"
      >{{item}}</div>
    </div>
  </div>
</template>

<script>
// 数字库区

import NumberSbjk from "./home/echarts01";
import NumberSsbj from "./home/echarts02";
import NumberZzl from "./home/echarts03";
import NumberDdgk from "./home/echarts04";
import btms from "./home/buttommodule";

import LyHeader from "./common/Header";

var left_panel = false;
var timer_ = null;
var hiddenProperty =
  "hidden" in document
    ? "hidden"
    : "webkitHidden" in document
    ? "webkitHidden"
    : "mozHidden" in document
    ? "mozHidden"
    : null;
var visibilityChangeEvent = hiddenProperty.replace(
  /hidden/i,
  "visibilitychange"
);
var onVisibilityChange = function() {
  if (!document[hiddenProperty]) {
    if (left_panel == true) {
      window.location.reload();
    }

    //window.history.go(0)
  } else {
    clearTimeout(timer_);

    timer_ = setTimeout(() => {
      left_panel = true;
    }, 5000);
  }
};
document.addEventListener(visibilityChangeEvent, onVisibilityChange);

setTimeout(() => {
  window.location.reload();
}, 3000000);

// three.js依赖
import * as THREE from "three";
import { OrbitControls } from "../assets/src/jsm/controls/OrbitControls";

import Stats from "../assets/src/jsm/libs/stats.module.js";
import { threex } from "./threex.js";
import { Convery } from "./Convery.js";
import { Box_info } from "./Box_info.js";
//tween动画
import { TweenLite, TweenMax } from "gsap";

import { Box3, Vector3 } from "three";
import {
  TSJ_Message_Handle_,
  TSJ_Move_,
  Init_Device_pos,
  JBJ_handle,
  JBJ_action,
  CDJ_action,
  CDJ_handle,
  SetBox,
  CDJ_Error_Handle,
  box_1003_move,
  InitBox,
  Destroy_Error_box,
  Handle_error,
  MPJ_Handle,
  CDJ_task_handle,
  ss_1006_box
} from "./Device.js";

var lx = null;
var d_lx = null;
var tp_group = null;
var tp_empty = null;
var single_box = null;
var isdui = false;
var iszhuan = false;
var Box_Info_Dict = new Array();
var canvas_Dict = new Array();
var ss_1046 = {
  obj: null,
  box: null,
  speed: null,
  isroll: null
};
var group;
var arr;
var convery_dic = new Array();
var box_dic = new Array();
var ss_1008_box = null;
var sprite_Dict=new Array();

export default {
  name: "Number",
  data() {
    return {
      stats: null,
      camera: null, //相机
      scene: null, //场景
      renderer: null, //渲染器
      ambientLight: null, //环境光
      pointlight: null, //点光源
      controls: null,
      cube: null, //控制器
      raycaster: null,
      mouse: null,
      fps: null,
      position: { x: 0.000001, y: 1.760582, z: 0 },
      rotation: { x: 0, y: 1.5707963267948966, z: 0 },
      socket: null,
      colliderObject: null,
      indeximg: 0,
      msg: "隐藏面板",
      msg1: "站台",
      arr: ["全局", "入库区", "出库区", "钢平台"],
      positionData: [
        {
          //全局
          position: {
            x: -49.22627987959302,
            y: 26.420824707372468,
            z: -20.64813721379847
          },
          rotation: {
            x: -2.422522805745374,
            y: -0.6325467368995576,
            z: -2.664003025577719
          }
        },
        {
          //入库区
          position: {
            x: -18.149895695541037,
            y: 8.16593349309362,
            z: -13.920964917333034
          },
          rotation: {
            x: -2.6885304590152233,
            y: -0.2097978061878578,
            z: -3.040548149835738
          }
        },
        {
          //出库区
          position: {
            x: -19.14459384842255,
            y: 13.399979893860252,
            z: 0.24613163178067674
          },
          rotation: {
            x: -1.5528225369557762,
            y: -1.0192484293304878,
            z: -1.5496941162665834
          }
        },
        {
          //钢平台
          position: {
            x: -28.563064529304217,
            y: 16.10645835504448,
            z: -5.059190354173687
          },
          rotation: {
            x: -2.7104089010877037,
            y: 0.027949665419469166,
            z: 3.128736665565056

          }
        }
      ],
      isShowstyle: true,
      img: null
    };
  },
  methods: {
    hideBtn() {
      // alert(6666);
      this.isShowstyle = !this.isShowstyle;
    },
    indexchange(index) {
      var _this = this;
      this.indeximg = index;
     
      this.moveCamera(_this.camera, 2, this.positionData[index].position,this.positionData[index].rotation);
      switch (index) {
        case 0:
          this.controls.target = new THREE.Vector3(-16.525, 2, 0);
          break
          case 1:
             this.controls.target = new THREE.Vector3(-20.525, 2, 1.695);
            break;
        case 2:
         this.controls.target = new THREE.Vector3(-4.5, 2, 0);
          break;
          case 3:
            this.controls.target = new THREE.Vector3(-30.525, 3.3, 10);
         
          break;
      
        default:
          break;
      }
       
    },
    moveCamera(obj, time, position,rotation) {
      TweenMax.to(obj.position, time, position);
      TweenMax.to(obj.rotation, time, rotation);
    },
    init() {
      var _this = this;
      // this.stats = new Stats();
      // var cont = document.getElementById("model");
      // cont.appendChild(this.stats.dom);
      //场景
      this.scene = new THREE.Scene();
      this.scene.background = new THREE.Color(0x04092d); //场景的背景
      group = new THREE.Group();
      this.scene.add(group);

      //实例碰撞体对象
      this.colliderObject = new threex.colliderObject();
      this.colliderObject.scene = this.scene;
      window.collider = this.colliderObject;

      // 相机
      this.camera = new THREE.PerspectiveCamera(
        50,
        window.innerWidth / window.innerHeight,
        0.01,
        10000000.0
      );
      this.camera.position.set(
        -17.094404975940176,
        15.636280845323615,
        -35.02176660427984
      );
      this.camera.rotation.set(
        -2.775804657112068,
        0.02006439904389895,
        3.1339081462603793
      );

      //this.camera.lookAt(0, 200, 0);

      // 渲染器
      this.renderer = new THREE.WebGLRenderer({
        antialias: true //抗锯齿
      });
      this.renderer.shadowMap.enabled = true; //开启阴影
      this.renderer.setClearColor(new THREE.Color(0xeeeeee));
      this.renderer.setSize(window.innerWidth, window.innerHeight);
      document.getElementById("model").appendChild(this.renderer.domElement);

      // 光源
      this.ambientLight = new THREE.AmbientLight(0xd7efff);
      this.ambientLight.position.set(0, 0, 0);
      this.ambientLight.intensity = 1;

      this.pointlight = new THREE.PointLight(0xffffff);
      this.pointlight.position.set(-36.815, 80.716, 97.64);
      this.pointlight.intensity = 0.8;
      this.pointlight.castShadow = true;
      this.pointlight.shadow.mapSize.width = 4096; //阴影质量
      this.pointlight.shadow.mapSize.height = 4096;

      this.scene.add(this.pointlight);
      this.scene.add(this.ambientLight);

      //this.object = new THREE.Object3D();
      //this.scene.add( this.object );

      // 控制器
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);

      this.controls.target = new THREE.Vector3(-21, 0, 0);
      this.controls.enableRotate = true;
      this.controls.screenSpacePanning = false;
      this.controls.minDistance = 1;
      this.controls.maxDistance = 70;
      this.controls.maxPolarAngle = Math.PI / 2.01;

      // 加载模型
      this.addScene("Aera01.json");
      this.addScene("Aera01_Box.json");
      this.addScene("Aera02.json");
      this.addScene("Aera02_Box.json");
      this.addScene("Aera03.json");
      this.addScene("Aera03_Box.json");
      this.addScene("Aera04.json");
      this.addScene("Aera04_Box.json");
      this.addScene("DiXing.json");
      this.addScene("HuoJia.json");
      this.addScene("lx.json");
      this.addScene("TP_Group.json");
      this.addScene("tp_empty.json");
      this.addScene("double_lx.json");
      this.addScene("single_box.json");
      this.addScene("title.json");
      this.addScene("DiNiu.json");
      this.addScene("KBX_G.json");
      this.addScene("LX-G.json");
      // 监听窗口变化
      window.addEventListener("resize", this.onWindowResize, false);
      // 监听单击事件
      window.addEventListener("click", this.MouseClick, false);
    },
    create_info_panel(cur, end, tasknum, parent) {
      var _this = this;
      var canvas = _this.generateSprite(cur, end, tasknum);
      canvas.name = tasknum;
      if (!canvas_Dict[canvas.name]) {
        canvas_Dict[canvas.name] = canvas;
      }
      var texture = new THREE.CanvasTexture(canvas);
      texture.needsUpdate = true;
      let material = new THREE.SpriteMaterial({
        map: texture
        //color: '#69f',
      });
      var sprite = new THREE.Sprite(material);
      sprite.scale.set(2, 1.2, 1);
      _this.scene.add(sprite);
      parent.attach(sprite);
      return sprite;
      //sprite.position.set(pos);
    },
    addModel(name) {
      var _this = this; //加载gltf模型（一次压缩）
      let self = this;
      var loader = new GLTFLoader();
      loader.load("../../static/model/" + name, function(gltf) {
        _this.scene.add(gltf.scene);
      });
    },
    generateSprite(cur, end, tasknum) {
      var _this = this;
      var canvas = document.createElement("canvas");
      canvas.style.width = "360px";
      canvas.style.height = "227px";
      var context = canvas.getContext("2d"); // 绘制图片
      context.beginPath();
      context.drawImage(_this.img, 0, 0, 300, 150);
      context.stroke();
      context.font = " 30px '微软雅黑'";
      var gradient = context.createLinearGradient(0, 0, 360, 0);
      gradient.addColorStop("1.0", "#fff");

      context.fillStyle = gradient;
      context.fillText("当  前  站  台 :", 40, 50, 80);
      context.fillText(cur, 130, 50, 100);
      context.fillText("目  标  站  台 :", 40, 90, 80);
      // time = time.slice(5, 19);
      context.fillText(end, 130, 90, 150);
      context.fillText("任  务  顺  序 :", 40, 130, 80);
      context.fillText(tasknum, 130, 130, 70);
      //context.fillStyle = "#ff0000";

      return canvas;
    },
    MouseClick(e) {
      // 鼠标拾取

      this.raycaster = new THREE.Raycaster();
      this.mouse = new THREE.Vector2();
      this.mouse.x = (e.clientX / window.innerWidth) * 2 - 1;
      this.mouse.y = -(e.clientY / window.innerHeight) * 2 + 1;
      this.raycaster.setFromCamera(this.mouse, this.camera);
      let intersects = this.raycaster.intersectObjects([this.scene], true);

      if (intersects.length > 0) {
        var selectedObject = intersects[0].object;
        var worldPosition = new THREE.Vector3();

        if (selectedObject.parent != null) {
          this.fps =
            "name：" +
            JSON.stringify(selectedObject.parent.name) +
            "</br>" +
            "position:" +
            JSON.stringify(selectedObject.getWorldPosition(worldPosition)) +
            "</br>" +
            "roation:" +
            JSON.stringify(selectedObject.rotation);
        } else {
          this.fps =
            "name：" +
            JSON.stringify(selectedObject.name) +
            "</br>" +
            "position:" +
            JSON.stringify(selectedObject.getWorldPosition(worldPosition)) +
            "</br>" +
            "roation:" +
            JSON.stringify(selectedObject.rotation);
        }
      }
    },
    onProgress() {
      //加载过程中
    },
    onError() {
      //加载失败
    }, //加载模型

    addScene(name) {
      var objectLoader = new THREE.ObjectLoader();
      let sf = this;
      objectLoader.load(
        "../../static/model/" + name,
        obj => {
          var _this = this;
          //所有模型都加载完成
          if (
            name == "lx.json" ||
            name == "tp_empty.json" ||
            name == "TP_Group.json" ||
            name == "double_lx.json" ||
            name == "single_box.json"
          ) {
            if (name == "lx.json") {
              lx = obj;
              window.lx = lx;
            }
            if (name == "tp_empty.json") {
              tp_empty = obj;
            }
            if (name == "TP_Group.json") {
              tp_group = obj;
            }
            if (name == "double_lx.json") {
              d_lx = obj;

              //InitBox(obj);
            }
            if (name == "single_box.json") {
              single_box = obj;
            }
          } else {
            this.scene.add(obj);
            if (
              name == "Aera01_Box.json" ||
              name == "Aera02_Box.json" ||
              name == "Aera03_Box.json" ||
              name == "Aera04_Box.json"
            ) {
              group.add(obj);
              arr = new Array();
              group.traverse(m => {
                if (m instanceof THREE.Mesh) {
                  arr.push(m);
                }
              });

              for (var i = 0; i < arr.length; i++) {
                sf.colliderObject.init(arr[i]);
                // var con=new Convery(sf.scene,arr[i].name)
                if (convery_dic[arr[i].name] == null) {
                  convery_dic[arr[i].name] = arr[i];
                }
              }
            }

            if (name == "Aera02.json") {
              // this.Device_pos_Init();

              Init_Device_pos(this.scene);

              //监听方法
              this.colliderObject.contactEnter = function(self, other) {
                // self.object3d.userData.helper.material.color.set('red')
                //self.object3d.userData.helper.material.wireframeLinewidth = 1
                arr.forEach(a => {
                  var b = this;
                  if (self.object3d.name == "liaoxiang") {
                    if (convery_dic[other.object3d.name]) {
                      convery_dic[other.object3d.name].box = self.object3d;

                      if (
                        other.object3d.name == "1119" ||
                        other.object3d.name == "1115" ||
                        other.object3d.name == "1111" ||
                        other.object3d.name == "1035" ||
                        other.object3d.name == "1044" ||
                        other.object3d.name == "1025"
                      ) {
                        setTimeout(() => {
                          _this.scene.remove(self.object3d);

                          convery_dic[other.object3d.name].box = null;
                        }, 3000);
                      }
                      if (other.object3d.name == "1037") {
                        //console.log(self.object3d.children[0])
                        // b.scene.attach(self.object3d.children[0])
                      }

                      if (other.object3d.name == "1056") {
                        // _this.scene.attach(self.object3d)
                        SetBox("1074", self.object3d);
                      }
                      if (other.object3d.name == "1076") {
                        SetBox("1077", self.object3d);
                      }
                      if (other.object3d.name == "1087") {
                        SetBox("1117", self.object3d);
                      }
                      if (other.object3d.name == "1096") {
                        SetBox("1113", self.object3d);
                      }
                      if (other.object3d.name == "1107") {
                        SetBox("1109", self.object3d);
                      }
                    }
                  }
                });
              };

              this.colliderObject.contactExit = function(self, other) {};

              this.socket = new WebSocket(
                encodeURI(
                  "ws://120.24.109.223:8008/api/yc/ws/scada/history?start_date=2019/05/30 00:00:00&end_date=2019/05/31 00:00:00"
                )
              );

              //监听
              this.socket.onopen = function(e) {};
              this.socket.onmessage = function(e) {
                // console.log("WebSocket收到消息: ", e.data, e);
                //self.GetData(e.data);
                var msg = JSON.parse(e.data);

                if (msg.channel == "longyan/scada/jbj/action/data") {
                  //console.log(msg.number);
                  JBJ_handle(e.data);
                }

                if (msg.channel == "longyan/scada/tsj/action/data") {
                  TSJ_Message_Handle_(e.data);
                }
                if (msg.channel == "longyan/scada/cdj/action/data") {
                  //_this.CDJ_handle(msg.asString());
                  CDJ_handle(e.data);
                }
                if (msg.channel == "longyan/scada/cdj/task/data") {
                  // CDJ_task_handle(e.data);
                }
                if (msg.channel == "longyan/scada/cmpj/action/data") {
                  MPJ_Handle(e.data);
                }

                if (msg.channel == "longyan/scada/dsyz/task/data") {
                  var action_info = JSON.parse(e.data);
                  if (action_info.number != null) {
                    var action_data = action_info.item;
                    for (var i = 0; i < action_data.length; i++) {
                      if (
                        action_data[i].label == "任务号" &&
                        action_data[i].value.length == 5
                      ) {
                        if (box_dic[action_data[i].value]) {
                          if (convery_dic[action_info.number]) {
                            TweenMax.to(
                              box_dic[action_data[i].value].position,
                              4,
                              {
                                x: convery_dic[action_info.number].position.x,
                                y: convery_dic[action_info.number].position.y,
                                z: convery_dic[action_info.number].position.z
                              }
                            );
                          }
                        }
                      }
                    }
                  }
                }
                if (msg.channel == "longyan/scada/dsyz/action/data") {
                  var action_info = JSON.parse(e.data);

                  if (action_info.number != null) {
                    var action_data = action_info.item;
                    for (var i = 0; i < action_data.length; i++) {
                      if (
                        action_data[i].label == "低位接近" &&
                        action_data[i].value == "False"
                      ) {
                        //正在往高位上升中

                        for (
                          let index = 0;
                          index < window.dsyzGroup.length;
                          index++
                        ) {
                          if (
                            Number(window.dsyzGroup[index].substring(0, 4)) ==
                            action_info.number
                          ) {
                            var obj1 = _this.scene.getObjectByName(
                              window.dsyzGroup[index]
                            );
                            if (obj1) {
                              TweenMax.to(obj1.children[2].position, 2, {
                                x: obj1.children[2].position.x,
                                y: 1.25,
                                z: obj1.children[2].position.z
                              });
                            }
                          }
                        }
                      }
                      if (
                        action_data[i].label == "高位接近" &&
                        action_data[i].value == "False"
                      ) {
                        //正在往下降

                        for (
                          let index = 0;
                          index < window.dsyzGroup.length;
                          index++
                        ) {
                          if (
                            Number(window.dsyzGroup[index].substring(0, 4)) ==
                            action_info.number
                          ) {
                            var obj1 = _this.scene.getObjectByName(
                              window.dsyzGroup[index]
                            );
                            if (obj1) {
                              TweenMax.to(obj1.children[2].position, 2, {
                                x: obj1.children[2].position.x,
                                y: 1.19,
                                z: obj1.children[2].position.z
                              });
                            }
                          }
                        }
                      }

                      if (
                        action_data[i].label == "正转运行" &&
                        action_data[i].value == "True"
                      ) {
                        if (action_info.number == 1049) {
                        }

                        if (convery_dic[String(action_info.number)]) {
                          //console.log(action_info.number,"正转运行")
                          convery_dic[String(action_info.number)].isroll = true;
                        }
                      }
                      if (
                        action_data[i].label == "正转运行" &&
                        action_data[i].value == "False"
                      ) {
                        // ss_1046.isroll=false;

                        if (convery_dic[String(action_info.number)]) {
                          //console.log(action_info.number,"停止转动")
                          convery_dic[
                            String(action_info.number)
                          ].isroll = false;
                        }
                      }
                    }
                  }
                }
                if (msg.channel == "longyan/scada/cmpj/action/data") {
                  var action_info = JSON.parse(e.data);
                  var action_data = action_info.item;
                  for (var i = 0; i < action_data.length; i++) {
                    if (action_data[i].label == "托盘数量") {
                      var num = action_data[i].value;
                      var y = 1.583;
                      for (let index = 0; index < num; index++) {
                        var b = tp_empty.clone();
                        _this.scene.add(b);
                        b.position.set(-17.894, y + index * 0.15, 3.156);
                      }
                    }
                  }
                }
                if (msg.channel == "longyan/scada/ssj/action/data") {
                  var action_info = JSON.parse(e.data);
                  box_1003_move(action_info);

                  if (action_info.number != null) {
                    var action_data = action_info.item;
                    for (var i = 0; i < action_data.length; i++) {
                      if (
                        action_data[i].label == "正转运行" &&
                        action_data[i].value == "True"
                      ) {
                      }
                      if (
                        action_data[i].label == "正转运行" &&
                        action_data[i].value == "False"
                      ) {
                        // ss_1046.isroll=false;

                        if (convery_dic[String(action_info.number)]) {
                          //console.log(action_info.number,"停止转动")
                          //convery_dic[String(action_info.number)].isroll=false;
                        }
                      }
                    }
                  }

                  if (action_info.number == 1120) {
                    var action_data = action_info.item;
                    for (var i = 0; i < action_data.length; i++) {
                      if (
                        action_data[i].label == "堆垛检测" &&
                        action_data[i].value == "True"
                      ) {
                        isdui = true;
                      }
                      if (
                        action_data[i].label == "堆垛检测" &&
                        action_data[i].value == "Flase"
                      ) {
                        isdui = false;
                      }
                      if (
                        action_data[i].label == "正转运行" &&
                        action_data[i].value == "True"
                      ) {
                        iszhuan = true;
                      }
                      if (
                        action_data[i].label == "正转运行" &&
                        action_data[i].value == "Flase"
                      ) {
                        iszhuan = false;
                      }
                    }
                  }
                }
                if (msg.channel == "longyan/scada/ssj/task/data") {
                  var action_info = JSON.parse(e.data);
                  var action_data = action_info.item;
                  var start = null;
                  var end = null;
                  if (action_info.number) {
                    for (var i = 0; i < action_data.length; i++) {
                      if (
                        action_data[i].label == "任务号" &&
                        action_data[i].value == "1000"
                      ) {
                        if (action_info.number == "1008") {
                          if (window.ss_1006_box) {
                            //ss_1006_box.name=="liangxiang";
                            _this.colliderObject.init(window.ss_1006_box);
                            TweenMax.to(window.ss_1006_box.position, 3, {
                              x: convery_dic["1008"].position.x,
                              y: convery_dic["1008"].position.y,
                              z: convery_dic["1008"].position.z,
                              onComplete: function() {
                                ss_1008_box = window.ss_1006_box;

                                window.ss_1006_box = null;
                              }
                            });
                          }
                        }
                      }

                      if (action_data[i].label == "目标地址") {
                        end = action_data[i].value;
                      }
                    }

                    var tp_type = null;
                    var task_num = null;
                    for (var i = 0; i < action_data.length; i++) {
                      if (action_data[i].label == "托盘类型") {
                        tp_type = action_data[i].value;
                      }
                      if (
                        action_data[i].label == "任务号" &&
                        action_data[i].value.length == 5
                      ) {
                        task_num = action_data[i].value;
                      }
                    }

                    if (task_num) {
                      if (Box_Info_Dict[task_num]) {
                        Box_Info_Dict[task_num].cur = action_info.number;
                        Box_Info_Dict[task_num].tasknum_ = task_num;
                      }
                      if (box_dic[task_num] == null) {
                        if (action_info.number == "1009") {
                          if (ss_1008_box) {
                            TweenMax.to(ss_1008_box.position, 3, {
                              x: convery_dic["1009"].position.x,
                              y: convery_dic["1009"].position.y,
                              z: convery_dic["1009"].position.z,
                              onComplete: function() {
                                ss_1008_box = null;
                                var s=_this.create_info_panel(action_info.number,end,task_num,box_dic[task_num])
                                s.position.set(0,0,1.5)
                                
                                if(!sprite_Dict[task_num]){
                                  sprite_Dict[task_num]=s;
                                  
                                }
                                
                              }
                            });
                            if (box_dic[task_num] == null) {
                              box_dic[task_num] = ss_1008_box;
                              
                            }
                          }
                        }
                      } else {
                        if (action_info.number == "1056") {
                          TweenMax.to(box_dic[task_num].position, 1.5, {
                            x: convery_dic[action_info.number].position.x,
                            y: convery_dic[action_info.number].position.y,
                            z: convery_dic[action_info.number].position.z,onComplete:function(){
                             
                            }
                          });
                        } else {
                          if (tp_type != "1") {
                            if (
                              action_info.number != "1056" &&
                              action_info.number != "1009"
                            ) {
                              if (convery_dic[action_info.number]) {
                                TweenMax.to(box_dic[task_num].position, 3, {
                                  x: convery_dic[action_info.number].position.x,
                                  y: convery_dic[action_info.number].position.y,
                                  z: convery_dic[action_info.number].position.z,
                                  onComplete: function() {
                                   
                                    
                                      if(sprite_Dict[task_num]){
                                        
                                          
                                        sprite_Dict[task_num].parent.remove(sprite_Dict[task_num])
                                        
                                        sprite_Dict[task_num]=null;
                                       
                                        var s=_this.create_info_panel(action_info.number,end,task_num,box_dic[task_num])
                                        switch (tp_type) {
                                          case "2":
                                            s.position.set(0,1.5,0);
                                            break;
                                            case "3":
                                            s.position.set(0,0,1.5);
                                            break;
                                            case "4":
                                              if(box_dic[task_num].children.length>1){
                                                s.position.set(0,0,1.5);
                                              }else{
                                                s.position.set(0,1.2,0);
                                              }
                                            
                                            break;
                                        
                                          default:
                                            break;
                                        }
                                        
                                        sprite_Dict[task_num]=s;
                                        if(task_num=="28606"&&action_info.number=="1076"){
                                          
                                          s.position.set(0,0,1.5);
                                        }
                                      }
                                     
                                    
                                  }
                                });
                              }
                            }
                          }
                        }
                      }
                    }
                    //任务号和托盘类型不为空
                    if (tp_type && task_num) {
                      if (box_dic[task_num] == null) {
                        switch (tp_type) {
                          case "2":
                            // //if 任务号字典中为空
                            if (box_dic[task_num] == null) {
                              if (convery_dic[action_info.number]) {
                                var box = tp_group.clone();

                                box.name = "liaoxiang";
                                //box.name=task_num;
                                _this.scene.add(box);
                                _this.colliderObject.init(box);
                                box.position.set(
                                  convery_dic[action_info.number].position.x,
                                  convery_dic[action_info.number].position.y,
                                  convery_dic[action_info.number].position.z
                                );

                                //   var b=box_dic[task_num];
                                //   b.tasknum=task_num;
                                //  b.cur=action_info.number;
                                //   b.end=end;
                                //  var s=_this.create_info_panel( b.cur,b.end,b.tasknum,box);
                                //  s.position.set(0,1.5,0)
                                 Box_Info_Dict[task_num] = new Box_info(
                                  box,
                                  task_num,
                                  action_info.number,
                                  end
                                );

                                //      box_dic[task_num].tasknum=task_num;
                                //   box_dic[task_num].cur=action_info.number;
                                //   box_dic[task_num].end=end;
                                var s = _this.create_info_panel(
                                  Box_Info_Dict[task_num].cur,
                                  Box_Info_Dict[task_num].end,
                                  Box_Info_Dict[task_num].tasknum_,
                                  box
                                );
                                s.position.set(0, 1.5, 0);
                                if(!sprite_Dict[task_num]){
                                  sprite_Dict[task_num]=s;
                                }

                                box_dic[task_num] = box;
                              }
                            }
                            break;
                          case "3":
                            if (box_dic[task_num] == null) {
                              if (convery_dic[action_info.number]) {
                                var box = lx.clone();

                                box.name = "liaoxiang";
                                //box.name=task_num;
                                _this.scene.add(box);
                                _this.colliderObject.init(box);
                                box.position.set(
                                  convery_dic[action_info.number].position.x,
                                  convery_dic[action_info.number].position.y,
                                  convery_dic[action_info.number].position.z
                                );
                                Box_Info_Dict[task_num] = new Box_info(
                                  box,
                                  task_num,
                                  action_info.number,
                                  end
                                );

                                //      box_dic[task_num].tasknum=task_num;
                                //   box_dic[task_num].cur=action_info.number;
                                //   box_dic[task_num].end=end;
                                var s = _this.create_info_panel(
                                  Box_Info_Dict[task_num].cur,
                                  Box_Info_Dict[task_num].end,
                                  Box_Info_Dict[task_num].tasknum_,
                                  box
                                );
                                s.position.set(0, 0, 1.5);
                                if(!sprite_Dict[task_num]){
                                  sprite_Dict[task_num]=s;
                                }
                                box_dic[task_num] = box;
                              }
                            }

                            break;

                          case "4":
                            if (box_dic[task_num] == null) {
                              if (convery_dic[action_info.number]) {
                                var box = single_box.clone();

                                box.name = "liaoxiang";
                                //box.name=task_num;
                                _this.scene.add(box);
                                _this.colliderObject.init(box);
                                box.position.set(
                                  convery_dic[action_info.number].position.x,
                                  convery_dic[action_info.number].position.y,
                                  convery_dic[action_info.number].position.z
                                );
                                //   box_dic[task_num].tasknum=task_num;
                                //   box_dic[task_num].cur=action_info.number;
                                //   box_dic[task_num].end=end;
                                //  var s=_this.create_info_panel( box_dic[task_num].cur,box_dic[task_num].end,box_dic[task_num].tasknum,box);
                                //  s.position.set(0,1.3,0)
                                 Box_Info_Dict[task_num] = new Box_info(
                                  box,
                                  task_num,
                                  action_info.number,
                                  end
                                );

                                //      box_dic[task_num].tasknum=task_num;
                                //   box_dic[task_num].cur=action_info.number;
                                //   box_dic[task_num].end=end;

                                
                                if(!sprite_Dict[task_num]){
                                  var s = _this.create_info_panel(
                                  Box_Info_Dict[task_num].cur,
                                  Box_Info_Dict[task_num].end,
                                  Box_Info_Dict[task_num].tasknum_,
                                  box
                                );
                                s.position.set(0, 1.2, 0);
                                  sprite_Dict[task_num]=s;
                                }
                                box_dic[task_num] = box;
                              }
                            }

                            break;

                          default:
                            break;
                        }
                      } else {
                      }
                    }
                  }
                }
              };
              this.socket.onclose = function(e) {};
              this.socket.onerror = function(e) {};

              // var client = emitter.connect({host:"127.0.0.1",port:"6800"}); // or: require('emitter-io') on NodeJS

              // // once we're connected, subscribe to the 'chat' channel
              // //提升机动作
              // client.subscribe({
              //   key: "UIPbf-9IhJpD7lgsVQbv-JcHBRXi2ZLW",
              //   channel: "longyan/scada/tsj/action/data"
              // });

              // //夹抱机动作
              // client.subscribe({
              //   key: "DT0VMwHJdkZG_zSla0w6VUx-7QtH1_MR",
              //   channel: "longyan/scada/jbj/action/data"
              // });
              // //拆垛机动作
              // client.subscribe({
              //   key: "JuFSeDWFLdYVlLAtTz3Uyyb9yD_fOaq2",
              //   channel: "longyan/scada/cdj/action/data"
              // });

              // //拆码盘机动作
              // client.subscribe({
              //   key: "wQsN_hBeIB4V8xvrx0fZ3yeLrFd7YwGV",
              //   channel: "longyan/scada/cmpj/action/data"
              // });
              //   client.subscribe({
              //   key: "0dAMbYMvwSMlSq4kgRJy1Rw8s0nGhpEy",
              //   channel: "longyan/scada/ssj/task/data"
              // });
              //    client.subscribe({
              //   key: "HMkBRvabFgqztC8-GRrGYfauQXpf8O7M",
              //   channel: "longyan/scada/ssj/action/data"
              // });

              // //on every message, print it out
              // client.on('message', function(msg){
              //   if(msg.channel=="longyan/scada/jbj/action/data/"){
              //    //_this.JBJ_handle(msg.asString());
              //    JBJ_handle(msg.asString());

              //   }
              //    if(msg.channel=="longyan/scada/tsj/action/data/"){

              //   TSJ_Message_Handle_(msg.asString());

              //   }
              //   if(msg.channel=="longyan/scada/cdj/action/data/"){
              //        //_this.CDJ_handle(msg.asString());
              //        CDJ_handle(msg.asString());
              //   }
              //   if(msg.channel=="longyan/scada/cmpj/action/data/"){
              //    MPJ_Handle(msg.asString());
              //   }
              //   if(msg.channel=="longyan/scada/ssj/action/data/"){
              //       var  action_info=JSON.parse(msg.asString());
              //        box_1003_move(action_info);
              //     if(action_info.number==1120){
              //     var action_data=action_info.item;
              //      for(var i=0;i<action_data.length;i++){
              //          if(action_data[i].label=="堆垛检测"&&action_data[i].value=="True"){
              //            isdui=true;
              //          }
              //           if(action_data[i].label=="堆垛检测"&&action_data[i].value=="Flase"){
              //             isdui=false;
              //          }
              //          if(action_data[i].label=="正转运行"&&action_data[i].value=="True"){
              //            iszhuan=true;
              //          }
              //           if(action_data[i].label=="正转运行"&&action_data[i].value=="Flase"){
              //             iszhuan=false;
              //          }

              //      }

              //      }

              //   }
              //   if(msg.channel=="longyan/scada/ssj/task/data/"){
              //   var  action_info=JSON.parse(msg.asString());
              //   if(action_info.number=="1076"){
              //     var action_data=action_info.item;
              //      for(var i=0;i<action_data.length;i++){

              //        if(action_data[i].label=="任务号"&&action_data[i].value.length==5){
              //          //console.log(action_data[i].value);
              //           var box=lx.clone();
              //           box.position.set(-24.261,1.637,6.214);

              //           _this.scene.add(box);
              //          //console.log("生成箱子")
              //          SetBox("1077",box);

              //        }
              //      }
              //   }

              //    if(action_info.number=="1087"){
              //     var action_data=action_info.item;
              //      for(var i=0;i<action_data.length;i++){

              //        if(action_data[i].label=="任务号"&&action_data[i].value.length==5){
              //          //console.log(action_data[i].value);
              //           var box=lx.clone();
              //           box.position.set(-20.214,5.6,15.298);

              //           _this.scene.add(box);
              //          //console.log("1087生成箱子")
              //          SetBox("1117",box);

              //        }
              //      }
              //   }
              //      if(action_info.number=="1096"){
              //     var action_data=action_info.item;
              //      for(var i=0;i<action_data.length;i++){

              //        if(action_data[i].label=="任务号"&&action_data[i].value.length==5){
              //          //console.log(action_data[i].value);
              //           var box=lx.clone();
              //           box.position.set(-31.056,5.6,15.298);

              //           _this.scene.add(box);
              //          //console.log("1096生成箱子")
              //          SetBox("1113",box);

              //        }
              //      }
              //   }
              //    if(action_info.number=="1056"){
              //     var action_data=action_info.item;
              //      for(var i=0;i<action_data.length;i++){

              //        if(action_data[i].label=="任务号"&&action_data[i].value.length==5){
              //          //console.log(action_data[i].value);
              //           var box=lx.clone();
              //           box.position.set(-18.049,1.5,6.402);

              //           _this.scene.add(box);
              //          //console.log("1056生成箱子")
              //          SetBox("1074",box);

              //        }
              //      }
              //   }

              //   }

              // });
            }
          }
        },

        this.onProgress,
        this.onError
      );
    },

    onWindowResize() {
      this.camera.aspect = window.innerWidth / window.innerHeight;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(window.innerWidth, window.innerHeight);
    },
    animate() {
      //动画函数
      let self = this;
      

      //console.log('**colliderObject**', this.colliderObject)
      this.colliderObject.requestAnimationFrame(function() {
        self.controls.update();
        //self.stats.update();
        self.renderer.render(self.scene, self.camera);
  // console.log(self.camera.position,self.camera.rotation)
        //console.log("pos",self.camera.position)
        //console.log("rot",self.camera.rotation)
        JBJ_action();

        //CDJ_action();
        if (isdui == true && iszhuan == true) {
          Destroy_Error_box();
          var box = d_lx.clone();
          box.position.set(-22.5, 1.5, -1.494);
          self.scene.add(box);

          console.log("1002生成箱子");
          SetBox("1002", box);
          iszhuan = false;
          isdui = false;
        }
        //Handle_error();
        TSJ_Move_();
      });

      //   requestAnimationFrame(this.animate);
      //     this.controls.update();
      //     this.stats.update();
      //     this.renderer.render(this.scene, this.camera);
    }
  },
  components: {
    LyHeader,
    NumberSbjk,
    NumberSsbj,
    NumberZzl,
    NumberDdgk,
    btms
  },
  mounted() {
    var _this = this;
    this.img = new Image();
    this.img.src = "../../../../static/img/blue.png";
    _this.img.onload = function() {
      _this.init();
      _this.animate();
    };

    window["test"] = () => {
      //this.create_info_panel();
    };
  }
};
</script>


<style scoped>
.content {
  width: 1918px;
  height: 853px;
  margin: 0 auto;
  position: relative;
  background-color: #348975;
  overflow: hidden;
}
.openBtn {
  position: fixed;
  top: 200px;
  left: 0;
  height: 35px;
  line-height: 35px;
  width: 100px;
  text-align: center;
  background-color: #999;
}
.jiankong {
  position: absolute;
  top: 150px;
  left: 40px;
}
.shuidi {
  width: 318px;
  position: absolute;
  left: 40px;
  top: 380px;
}
.shuidiimg {
  width: 100%;
}
.baojing {
  position: absolute;
  left: 40px;
  top: 480px;
}
.anniu {
  width: 318px;
  position: absolute;
  left: 40px;
  top: 700px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: start;
}
.anniu > div {
  text-align: center;
  font-size: 16px;
  color: #fff;
  margin-left: 40px;
  margin-top: 10px;
  cursor: pointer;
  width: 100px;
  height: 36px;
  line-height: 36px;
  background: url("../assets/img/btn-bg.png") no-repeat;
  background-size: 100% 100%;
}
.shebei {
  position: absolute;
  width: 318px;
  right: 40px;
  top: 150px;
}
.shebeiimg {
  width: 100%;
}
.zhouzhuanl {
  position: absolute;
  right: 40px;
  top: 250px;
}
.dingdan {
  position: absolute;
  right: 40px;
  top: 495px;
}
.gegekuqu {
  position: absolute;
  bottom: 40px;
  height: 76px;
  width: 440px;
  left: 50%;
  margin-left: -220px;
  display: flex;
  align-items: center;
}
.meige {
  width: 79px;
  height: 76px;
  background: url("../assets/img/weixuan.png") no-repeat 100% 100%;
  text-align: center;
  line-height: 76px;
  border-radius: 50%;
  margin-right: 20px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}
.xuanzhongimg {
  background: url("../assets/img/xuanzhong.png") no-repeat 100% 100%;
}
</style>





// WEBPACK FOOTER //
// src/components/xiayan/home/Number.vue